import React from 'react';

import { Wrapper, BodyText, Title, Section, StyledButton } from './styles';
import { ApIcon } from '@alixpartners/ui-components';
import { chartOrange, greenLightest2, greenLight3 } from 'styles/colors';

export const MessageWithAction = ({ title, content, button, isSuccess }) => {
	const iconName = isSuccess ? 'outline_done' : 'outline_error';
	const iconColor = isSuccess ? greenLight3 : chartOrange;
	const bgColor = isSuccess ? greenLightest2 : 'rgb(249, 161, 42, 0.1)';

	return (
		<Wrapper bgColor={bgColor}>
			<Section>
				<div>
					<ApIcon iconName={iconName} iconSize="24px" iconColor={iconColor} />
				</div>
			</Section>
			<Section>
				<Title>{title}</Title>
				<BodyText>{content}</BodyText>
			</Section>
			{button && (
				<Section>
					<StyledButton
						style={button.style}
						color={button.color}
						onClick={button.onClick}
					>
						{button.text}
					</StyledButton>
				</Section>
			)}
		</Wrapper>
	);
};
